const parseFloat = (value = '') => {
  if (typeof value !== 'string') return '';
  return value.replace(/^0+./, '0.').replace(',', '.').replace(/[^\d\.]/g, "").replace(/\./, "x").replace(/\./g, "").replace(/x/, ".");
};

export default parseFloat;